jQuery(function($){
  var currentViewPort = $(window).width();

  if (window.location.pathname != '/') {
    if ( currentViewPort > 976) {
      $('#productListMobile').remove();
    } else {
      $('#productListDesktop').remove();
    }
  }

  if (window.location.pathname != '/') {
    $(document).on('click', '.card__item--product', function(e) {
      var parentRowId = $(this).parents('div.row--products').attr('id');
      var currentViewPort = $(window).width();
      var data = {
        'action'     : 'product_details',
        'product_id' : $(this).data('id')
      };

      if (window.location.pathname != '/') {
        $('#productDetails').remove();
      }

      $.ajax({
        url : product.ajaxurl,
        data: data,
        type: 'POST',
        beforeSend: function (){
          if (window.location.pathname != '/') {
            if ( currentViewPort > 976) {
              // DESKTOP
              $(`#${parentRowId} > .col__item`).last().after('<div id="productDetails" class="col-12"><div class="product-details"></div></div>');
            } else {
              // MOBILE
              $(`#${parentRowId} > .col__item:nth-child(2)`).after('<div id="productDetails" class="col-12"><div class="product-details"></div></div>');
            }
          }
        },
        success:function(data) {
          $('.product__thumbnails').slick('unslick');
          $('.product-details').html(data);
          $('.product__thumbnails').slick({
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: false,
            arrows: false
          });
        },
        complete: function () {
          var scrollOffset = currentViewPort < 976 ? 40 : 100;
          setTimeout(function (){
            $([document.documentElement, document.body]).animate({
              scrollTop: $("#productDetails").offset().top - scrollOffset
            }, 500);

          }, 100);
        }
      });

      e.preventDefault();
    });
  }

  $(document).on('click', '.product__thumbnail-item', function() {
    let thumbnailId = $(this).data('thumbnail-id');
    $('.product__image-item').addClass('is-hidden');
    $('.product__image').find(`div[data-image-id="${thumbnailId}"]`).removeClass('is-hidden');
    $('.product__image').find(`div[data-image-id="${thumbnailId}"]`).addClass('is-visible');
  });

  $(document).on('click', 'input[name="product-variant"]', function() {
    let price =$(this).data('price');
    let variant_name = $(this).data('title');

    $('.btn-group--product-sizes .btn--variant').text(variant_name);
    $('.product__price').html('£' + price);
  });

  $(document).on('click', '.product__atc[data-action="atc"]', function(e) {
    let variant_type = $(this).data('variant-type');
    if ($(this).html() == 'View in basket') {
      window.location = 'basket';
    } else {

      if (variant_type == 'single') {
        let variant_id = $(this).data('variant-id');
        let args = {
          title       : $(this).data('title'),
          product     : $(this).data('product'),
          thumbnail   : $(this).data('thumbnail'),
          price       : $(this).data('price'),
          size        : $(this).data('title'),
          qty         : 1 //Add 1 qty by default
        }
        basketItem(variant_id, args);
      }

      if (variant_type == 'multiple') {
        let variant = $('[name="product-variant"]:checked');
        let variant_id = variant.val();
        let args = {
          title       : variant.data('title'),
          product     : variant.data('product'),
          thumbnail   : variant.data('thumbnail'),
          price       : variant.data('price'),
          size        : variant.data('title'),
          qty         : 1 //Add 1 qty by default
        }
        basketItem(variant_id, args);
      }

      $(this).html('View in basket');
      e.preventDefault();
    }
  });

  $(document).on('click', '.product__close-preview', function(e) {
    // $('.product-details').fadeOut(function(){
      // $('html, body').animate({
      //     scrollTop: $('#store-section').offset().top - 100
      // }, 800);
      $('.product-details--last').html('');
      $('.product-details').remove();
      $('.product-details').removeAttr('style');
    // });

    e.preventDefault();
  });

  $(document).on('click', '.product__option-value', function() {
    let target = $(this).parents('.product__option').find('input');
    let inventory_qty = target.data('inventory-qty');
    let action = inventory_qty > 0 ? 'atc' : 'soldout';
    let cart_action = action == 'atc' ? 'Add to cart' : 'Sold Out';

    // if (inventory_qty > 0) {

    // } else {
    //   $('.product_atc')
    // }


    $('.product__atc').attr( 'data-action', action );
    $('.product__atc').html( cart_action );
  });
});

function basketItem(variant, args) {
  let basket = localStorage.getItem('basket') ? JSON.parse(localStorage.getItem('basket')) : {};
  basket[variant] = args;

  localStorage.setItem('basket', JSON.stringify(basket));

  // Set basket count if exist
  if ( $('.basket__count').length ) {
    getBasketCount();
  }
}
